import React from 'react';
import PropTypes from 'prop-types';
import BasicDataPod from '../BasicDataPod';
import Link from '../BasicDataPod/Link';
import { getMonthString } from '../../utils/timestamp';
import './styles.css';

export default function DateDataPod({ content, ...rest }) {
  const { value, linkText, linkUrl, footerText } = content;
  let month;
  let day;

  if (value instanceof Date) {
    month = value.getMonth();
    day = value.getDate();
  } else {
    month = value.month;
    day = value.day;
  }

  // If any of the footer texts is longer than 24 characters, set the fontSize for all of them to 10px. This ensures that each footer text
  // fits on 1 line.
  let fontSize = 16;
  if (footerText && footerText.length) {
    footerText.forEach((footer) => {
      fontSize = footer.length > 24 ? 10 : fontSize;
    });
  }
  /* istanbul ignore next */
  return value ? (
    <BasicDataPod {...rest}>
      <div className="date-data-pod-container">
        <div className="date-data-pod-month">{getMonthString(month)}</div>
        <div className="date-data-pod-day">{day}</div>
      </div>
      {footerText &&
        footerText.map((footer, indx) => (
          <div
            key={indx}
            data-cy="date-data-pod-footer-text"
            className="date-data-pod-footer-text"
            style={{ fontSize: `${fontSize}px` }}
          >
            {footer}
          </div>
        ))}
      <Link linkText={linkText} linkUrl={linkUrl} />
    </BasicDataPod>
  ) : null;
}

DateDataPod.propTypes = {
  header: PropTypes.string,
  content: PropTypes.shape({
    value: PropTypes.object,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
    footerText: PropTypes.arrayOf(PropTypes.string),
  }),
};
